import { createFileRoute, Outlet } from "@tanstack/react-router";
import { getMessages, type Locale } from "$/modules/i18n/lib/i18n";

export const Route = createFileRoute("/$locale")({
	component: RouteComponent,
	staleTime: Infinity,
	loader: async ({ params }) => {
		const messages = await getMessages({
			locale: params.locale as Locale,
		});

		return {
			messages,
		};
	},
});

function RouteComponent() {
	return <Outlet />;
}
